import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2024-03-04
 * @brief SEI 커뮤니티 로그인 - 비밀번호 찾기 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue } from "recoil";
import { getApiLangState } from "../../../../recoil/langState";
import { findId } from "../../../../recoil/userState";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { useTrans } from "../../../../utils/langs/useTrans";
export default function CmmFindPwdPop(props) {
    const t = useTrans();
    //recoil
    const [recoilFindId, setRecoilFindId] = useRecoilState(findId);
    const apiLang = useRecoilValue(getApiLangState);
    //
    const [userId, setUserId] = useState(""); //test@test.com
    const [userName, setUserName] = useState(""); //bsKim
    const [userPhone, setUserPhone] = useState(""); //01000000001
    const [display, setDisplay] = useState(false);
    //20220824 추가
    const [errorList, setErrorList] = useState([]);
    const { data: data, run } = useAsync({
        deferFn: HTTPUTIL.Http,
        httpMethod: "PUT",
        appPath: "/auth/password/init",
        appQuery: {
            userId: userId,
            userName: userName,
            phoneNumber: userPhone,
            language: apiLang,
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == 200) {
                setRecoilFindId(data.body);
                setDisplay(true);
            }
            else {
                //20220824 추가
                setErrorList(data.errorList);
            }
        }
    }, [data]);
    useEffect(() => {
        setUserId(recoilFindId);
    }, [recoilFindId]);
    function handleSetUserId(val) {
        setErrorList(errorList.filter((err) => err.field !== "userId"));
        setUserId(val);
    }
    function handleSetUserName(val) {
        setErrorList(errorList.filter((err) => err.field !== "userName"));
        setUserName(val);
    }
    function handleSetPhoneNumber(val) {
        setErrorList(errorList.filter((err) => err.field !== "phoneNumber"));
        setUserPhone(val);
    }
    function Close(id) {
        setUserId(""); //test@test.com
        setUserName(""); //bsKim
        setUserPhone(""); //01000000001
        setDisplay(false);
        CUTIL.jsclose_Popup(id);
        setRecoilFindId("");
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "cmm-findPw", className: "popup-layer js-layer hidden inner-popup popup-type1 pop-login w350" }, { children: [_jsxs("div", Object.assign({ className: "popup__head", onClick: (e) => Close("cmm-findPw") }, { children: [_jsx("h1", { children: t("라벨.비밀번호찾기") }), _jsx("button", Object.assign({ className: "btn btn-close js-close" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "popup__body find-idpw" }, { children: [_jsx("form", Object.assign({ action: "", method: "", name: "popfindpw", style: { display: display ? "none" : "block" } }, { children: _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "findPw", className: "star" }, { children: t("라벨.아이디") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "findUserId", placeholder: "ex) abc@company.com", value: userId, className: errorList.filter((err) => err.field === "userId").length > 0 ? "input-error" : "", onChange: (e) => handleSetUserId(e.target.value), disabled: recoilFindId.length > 0 ? true : false }), " ", _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "userId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "username2", className: "star" }, { children: t("라벨.이름") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "username2", placeholder: t("라벨.이름입력"), value: userName, className: errorList.filter((err) => err.field === "userName").length > 0 ? "input-error" : "", onChange: (e) => handleSetUserName(e.target.value) }), " ", _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "userName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userphone1", className: "star" }, { children: t("라벨.연락처") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "tel", id: "userphone1", placeholder: t("라벨.숫자만입력"), value: userPhone, className: errorList.filter((err) => err.field === "phoneNumber").length > 0 ? "input-error" : "", onChange: (e) => handleSetPhoneNumber(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "phoneNumber").map((err) => err.msg) }))] }))] })] })) })), _jsxs("div", Object.assign({ className: "complete-txt", style: { display: !display ? "none" : "block" } }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("새비밀번호") })), _jsx("p", { children: recoilFindId })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [!display && (_jsx("button", Object.assign({ type: "button", className: "js-close bg-gray", onClick: (e) => Close("cmm-findPw") }, { children: _jsx("span", { children: t("라벨.취소") }) }))), !display ? (_jsx("button", Object.assign({ type: "button", onClick: run }, { children: _jsx("span", { children: t("라벨.찾기") }) }))) : (_jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => Close("cmm-findPw") }, { children: _jsx("span", { children: t("라벨.확인") }) })))] }))] })) }));
}
